module.exports = __webpack_public_path__ + "static/media/switcher-question.fc0349d5.png";